
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/les-outils/planning-de-traitement",
      function () {
        return require("private-next-pages/les-outils/planning-de-traitement/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/les-outils/planning-de-traitement"])
      });
    }
  